// extracted by mini-css-extract-plugin
export default {"adaIcon":"AdaIcon_adaIcon__1uAM0"};